import { Circulo } from './styles'

export const BotaoAdicionar = () => <Circulo to="/novo">+</Circulo>
